"use client";

import React, { useState, useEffect } from "react";

interface AgeCalculatorProps {
  birthDate: string; // Format: "YYYY-MM-DD"
}

export default function AgeCalculator({ birthDate }: AgeCalculatorProps) {
  const [age, setAge] = useState({ years: 0, months: 0 });

  useEffect(() => {
    const calculateAge = () => {
      const birth = new Date(birthDate);
      const now = new Date();

      let years = now.getFullYear() - birth.getFullYear();
      let months = now.getMonth() - birth.getMonth();

      // Adjust for negative months
      if (months < 0) {
        years--;
        months += 12;
      }

      setAge({ years, months });
    };

    calculateAge();
    
    // Update every hour to keep it current
    const interval = setInterval(calculateAge, 1000 * 60 * 60);
    
    return () => clearInterval(interval);
  }, [birthDate]);

  return (
    <span className="text-terminal-cyan font-medium">
      {age.years}y {age.months}m
    </span>
  );
}